import React from 'react';
import RentalAdminLayout from '../../../../../layout/equipmentrentaladmin/RentalAdminLayout.js';
import MechanicDetail from '../../../../../components/user/maintain/mechanicdetail/MechanicDetail.js';

const MechanicDetailPage = () => {
    return (
        <RentalAdminLayout>
            <MechanicDetail />
        </RentalAdminLayout>
    );
}

export default MechanicDetailPage;